import parse from 'html-react-parser'
import React, { type PropsWithChildren } from 'react'

import Headline from '@components/atoms/Headline'
import { HeadlineImportances } from '@components/atoms/Headline/Headline'
import { TextVariants } from '@components/atoms/Text/Text'
import { TextParagraph } from '@components/atoms/Text/Text.styles'

import { parseOptions } from '@helper/parseOptions'
import { type PropsWithClassName } from '@helper/PropsWithClassName'

import { Dd, Dl, Dt, Root } from './OpeningHours.styles'

interface Props extends PropsWithClassName {
  data: {
    weekdays: string
    saturday: string
    sunday: string
    publicHoliday: string
    lastEntrance: string
    title: string
    specialOpeningHour: string
  }
}

const OpeningHours: React.FC<PropsWithChildren<Props>> = (
  props: PropsWithChildren<Props>
): React.JSX.Element => {
  const { data } = props
  return (
    <Root className={props.className} data-testid={'opening-hours-root'}>
      <Headline importance={HeadlineImportances.h4}>
        {data.title ?? 'Öffnungszeiten'}
      </Headline>
      <TextParagraph variant={TextVariants.paragraph} as="div">
        <Dl>
          {data.weekdays ? (
            <>
              <Dt>Montag – Freitag:</Dt>
              <Dd>{data.weekdays}</Dd>
            </>
          ) : null}
          {data.saturday ? (
            <>
              <Dt>Samstag:</Dt>
              <Dd>{data.saturday}</Dd>
            </>
          ) : null}
          {data.sunday ? (
            <>
              <Dt>Sonntag:</Dt>
              <Dd>{data.sunday}</Dd>
            </>
          ) : null}
          {data.publicHoliday ? (
            <>
              <Dt>Feiertage:</Dt>
              <Dd>{data.publicHoliday}</Dd>
            </>
          ) : null}
          {data.lastEntrance ? (
            <>
              <Dt>Letzter Einlass:</Dt>
              <Dd>{data.lastEntrance}</Dd>
            </>
          ) : null}
          {data.specialOpeningHour ? (
            <>{parse(data.specialOpeningHour, parseOptions)}</>
          ) : null}
        </Dl>
      </TextParagraph>
    </Root>
  )
}

export { OpeningHours }
